import {SidepanelSize} from 'ui-library/reactflow/sidepanels/FlowchartContextPanel';
import {SidepanelType} from 'ui-library/reactflow/sidepanels/sidepanel-manager/useFlowchartSidepanelManager';

const TEXT_INPUT_TYPES = new Set([
  'text',
  'password',
  'email',
  'search',
  'url',
  'tel',
  'number',
  'date',
  'time',
  'datetime-local',
  'month',
  'week',
  'color',
]);

function isTextInputElement(el: HTMLElement): boolean {
  return (
    el.isContentEditable ||
    el.tagName === 'TEXTAREA' ||
    (el.tagName === 'INPUT' && TEXT_INPUT_TYPES.has((el as HTMLInputElement).type.toLowerCase()))
  );
}

export interface ShouldBlockDeleteKeyPressParams {
  target: HTMLElement;
  reactFlowWrapper?: HTMLElement | null | undefined;
  leftSidepanel?: HTMLElement | null | undefined;
  rightSidepanel?: HTMLElement | null | undefined;
  openSidepanelType?: SidepanelType | null | undefined;
  rightPanelSize?: SidepanelSize | null | undefined;
}

/**
 * Determines whether a Delete/Backspace keypress to trigger deleting node(s) or edge(s) should be blocked
 * based on the current focus target, sidepanel state, and canvas containment.
 */
export function shouldBlockDeleteKeyPress({
  target,
  reactFlowWrapper,
  leftSidepanel,
  rightSidepanel,
  openSidepanelType,
  rightPanelSize,
}: ShouldBlockDeleteKeyPressParams): boolean {
  if (isTextInputElement(target)) {
    return true;
  }

  const isTargetInCanvasArea =
    reactFlowWrapper?.contains(target) &&
    !leftSidepanel?.contains(target) &&
    !rightSidepanel?.contains(target);
  if (!isTargetInCanvasArea) {
    return true;
  }

  if (
    openSidepanelType === SidepanelType.NODE_SETTINGS &&
    (rightPanelSize == null || rightPanelSize === SidepanelSize.FULL)
  ) {
    return true;
  }

  return false;
}
